<!--
 * @Description: 钱账通商户抽屉组件
 * @Author: gaohc
 * @Date: 2023-10-19 16:43:52
 * @LastEditTime: 2024-01-02 13:55:30
-->
<template>
  <div class="mch-apply-body">
    <el-drawer label="rtl" size="1000px" :title="mchApplyTitle" :visible.sync="visible" 
      :before-close="handleClose" @open="initData">
      <div class="tips">
        <i class="el-icon-warning"></i>
        <span>平台已开通钱账通功能，请在此处提交资料，审核成功后服务收入方可到账银行账户</span>
      </div>
      <div class="container">
        <iframe :src="mchApplySrc" width="100%" height="100%"
          title="mchApply" name="mchApply">
        </iframe>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import Constant from '@/global/Constant.js'
export default {
  name: 'MchApplyDrawer',
  props: ['visible', 'currentInstData', "mode"],

  data() {
    return {
      mchApplyTitle: '',
      mchApplySrc: ''
    }
  },
  
  methods: {
    initData() {
      this.mchApplyTitle = (this.mode == 'add' ? '申请钱账通会员·' : '编辑钱账通会员·') 
        + this.currentInstData.name;
      let params = {'instId': this.currentInstData.id};
      let header = this.encryptionUtil.signatureParams(params,
        Constant.SIGNATURE_KEY_NAME, Constant.SIGNATURE_KEY);
      let requestData = {
        method: 'GET',
        url: Constant.URL_GET_URL_4OPEN_MERCHANT,
        param: params,
        header: header,
        contentType: this.commonConst.CNTYPE_URLENCODED,
      };

      this.vueRequest(requestData).then(result => {
        if (result == null) {
          return;
        }
        this.mchApplySrc = result.data;
      })
    },

    handleClose() {
      this.$emit('close-drawer', false);
    },
  },
}
</script>

<style scoped>
.mch-apply-body {
  margin: 0;
  text-align: center;
  border: solid 0px;
}

.mch-apply-body .tips {
  padding: 0 30px;
  height: 38px;
  display: flex;
  align-items: center;
  text-align: left;
  background: #F7F9FE;
  margin: 9px 0px 24px 0px;
}

.mch-apply-body .tips i {
  color: #E9A338;
  font-size: 14px;
}

.mch-apply-body .tips span {
  font-size: 12px;
  color: #606266;
  line-height: 16px;
  margin-left: 12px;
}

.mch-apply-body .container {
  height: 515px;
  padding: 0 30px;
  background: #FFFFFF;
}

</style>
<style>
.mch-apply-body .el-drawer {
  border-radius: 12px 0px 0px 12px;
}

.mch-apply-body .el-drawer__header {
  padding: 15px 40px 15px !important;
}

.mch-apply-body .el-drawer__close-btn {
    position: absolute;
    top: 15px;
    right: 40px !important;
}
</style>


// WEBPACK FOOTER //
// src/components/memmng/components/ApplyMember.vue